import React from 'react';

import InfoBox from 'lib/misc/InfoBox';

export default function Monster() {
    return (
        <>
            <iframe src="/various/monster" width="100%" height="100%" />
            <InfoBox
                title="Little Monster Game"
                position={[1, -2, 0]}
            >
                <ul>
                    <li>Monster modeled, textured, rigged and animated with Blender.</li>
                    <li>Gamelogic made with Three.js.</li>
                    <li>Included as IFrame here (I made it years ago with an old version of Three.js).</li>
                    <li>Floor-image taken from free img-library: http://seamless-pixels.blogspot.de/2012/09/free-seamless-ground-textures.html.</li>
                    <li>Background: 360° panorama taken from http://photoflap.wordpress.com/2012/06/06/the-singing-sand-dune/.</li>
                    <li>Laughing from http://freesound.org/people/sandyrb/ </li>
                    <li>Roaring from http://static1.grsites.com/archive/sounds/animals/animals032.wav </li>
                </ul>
            </InfoBox>
        </>
    )
}

